import { Component } from '@angular/core';
import { DynamicModalService } from '../../../../core/services/dynamic-modal.service';
import { SocketService } from '../../../../core/services/socket.service';

@Component({
  selector: 'app-list-sp',
  templateUrl: './list-sp.component.html',
  styleUrl: './list-sp.component.scss',
})
export class ListSpComponent {
  constructor(
    private socketService: SocketService,
    private dynamicModal: DynamicModalService,
  ) {
    this.socketService.joinRoom('abonos y pagos');
  }

  ngOnDestroy(): void {
    this.dynamicModal.closeModal();
    this.socketService.leaveRoom('abonos y pagos');
  }
}
